<template lang="">
    <div>
        <ManageMyQualification :staff_id="$store.getters.currentUserId"/>
        <br>
        <ManageMySkiil :staff_id="$store.getters.currentUserId"/>
    </div>
</template>
<script>
import ManageMyQualification from '@/views/pages/user-settings/training-qualifications/ManageMyQualification.vue'
import ManageMySkiil from '@/views/pages/user-settings/training-qualifications/ManageMySkiil.vue'
export default {
    name: 'MySkillQualificationHome',
    components: {
        ManageMyQualification,
        ManageMySkiil
    }
}
</script>
<style lang="">

</style>